// ============================================================================
// BOOK STATUS — single source of truth for the book launch state.
// ============================================================================
// FLIP THIS FLAG WHEN THE PROOF COPY PASSES INSPECTION:
//   1. Change BOOK_STATUS from "PRE_LAUNCH" to "LIVE"
//   2. Redeploy
//   → Every "Notify Me" button on the site instantly becomes "Buy Now on Lulu"
//   → The book hero on the Shop (home) page activates the live Lulu link
//   → /book page CTA flips from email capture to Buy button
// ============================================================================

export const BOOK_STATUS = "LIVE"; // "PRE_LAUNCH" | "LIVE" — Republished June 24, 2026 (new public URL after Lulu wizard fix)

// v2 Premium Edition — 6x9, 80# white paper, full wraparound cover
// Published to Lulu Bookstore: June 24, 2026
// ISBN: 979-8-9964172-1-6
export const LULU_BOOKSTORE_URL =
  "https://www.lulu.com/shop/temple-franklin/stop-saying-i-have-to-start-living-i-get-to/paperback/product-q6q5m4k.html";

// Live Amazon paperback (v2, 6x9, ISBN 979-8-9964172-1-6) — reviews accumulate here.
export const AMAZON_BOOK_URL = "https://www.amazon.com/dp/B0HD8ZKS3J";

export const BOOK_PRICE_USD = 19.99;
export const BOOK_PRICE_LABEL = "$19.99";

export const isBookLive = () => BOOK_STATUS === "LIVE";
